import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import {
  BridgeAdUnitDpHbIdStatus,
  BridgeAdUnitDpHbIdStatusKL,
  BridgeAdUnitDpHbIdStatusLabels
} from '../../../../shared/domain/bridge-ad-unit-hb-id-status.enum';
import { GlobalSpinnerService } from '../../../../shared/components/loader-service/global-spinner.service';
import { Principal } from '../../../../shared/auth/principal.service';
import { AdStatsBridgeAdUnitsService } from '../../../../shared/services/ad-stats-bridge-ad-units.service';
import { SnackBarService } from '../../../../shared/services/snackbar.service';
import { DemandPartnerDbName } from '../../domain/demand-partner.enum';
import { DpAutocreationPubmaticComponent } from './dp-autocreation-pubmatic-dialog.component';
import { BridgeAdUnitDpHbId } from '../../../../shared/domain/bridge-ad-unit-hb-id.model';
import { DpAutocreationAppnexusDialogComponent } from './dp-autocreation-appnexus-dialog.component';
import { ServerErrorUtils } from '../../../../shared/utils/server-error-utils';
import { DpAutocreationRubiconDialogComponent } from './dp-autocreation-rubicon-dialog.component';
import { DpConnectorsService } from '../../services/dp-connectors.service';

@Component({
  selector: 'cm-unit-hb-id-for-dp-dialog',
  templateUrl: './unit-hb-id-for-dp-dialog.component.html',
  styleUrls: ['./unit-hb-id-for-dp-dialog.component.scss']
})
export class UnitHbIdForDpDialogComponent {

  hbIds: BridgeAdUnitDpHbId[] = [];

  BridgeAdUnitDpHbIdStatus = BridgeAdUnitDpHbIdStatus;
  BridgeAdUnitDpHbIdStatusLabels = BridgeAdUnitDpHbIdStatusLabels;
  BridgeAdUnitDpHbIdStatusKL = BridgeAdUnitDpHbIdStatusKL();
  DemandPartnerDbName = DemandPartnerDbName;
  demandPartner: string;

  constructor(public dialogRef: MatDialogRef<UnitHbIdForDpDialogComponent>,
              private gss: GlobalSpinnerService,
              private principal: Principal,
              private service: AdStatsBridgeAdUnitsService,
              private sbs: SnackBarService,
              private dpService: DpConnectorsService,
              private matDialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any) {

    this.hbIds = data.hbIds;
    this.demandPartner = data.dp;
  }

  isIndexOrRubicon(demandPartner: string) {
    return demandPartner === 'Index' || demandPartner === 'Rubicon';
  }

  createUnitAtDp(hbId: BridgeAdUnitDpHbId) {
    switch (hbId.demandPartner) {
      case DemandPartnerDbName.OPENX_HB:
        this.gss.showLoader();
        this.service.adUnitsCreateOpenxUnit(hbId.bridgeAdUnitId).subscribe(next => {
          Object.assign(hbId, next);
          this.sbs.success('Unit created successfully');
          this.gss.hideLoader();
        }, (e) => {
          const messages = ServerErrorUtils.getValidationMessages(e);
          if (messages) {
            messages.forEach(m => this.sbs.error(m));
          } else {
            this.sbs.error('Unexpected error occurred');
          }
          this.gss.hideLoader();
        });
        break;
      case DemandPartnerDbName.SPOTX:
        this.gss.showLoader();
        this.dpService.adUnitsCreateSpotxUnit(hbId.bridgeAdUnitId).subscribe(next => {
          Object.assign(hbId, next);
          this.sbs.success('Unit created successfully');
          this.gss.hideLoader();
        }, (e) => {
          const messages = ServerErrorUtils.getValidationMessages(e);
          if (messages) {
            messages.forEach(m => this.sbs.error(m));
          } else {
            this.sbs.error('Unexpected error occurred');
          }
          this.gss.hideLoader();
        });
        break;
      case DemandPartnerDbName.SOVRN:
        this.gss.showLoader();
        this.service.adUnitsCreateSovrnUnit(hbId.bridgeAdUnitId).subscribe(next => {
          this.sbs.success('Unit created successfully');
          Object.assign(hbId, next);
          this.gss.hideLoader();
        }, (e) => {
          const messages = ServerErrorUtils.getValidationMessages(e);
          if (messages) {
            messages.forEach(m => this.sbs.error(m));
          } else {
            this.sbs.error('Unexpected error occurred');
          }
          this.gss.hideLoader();
        });
        break;
      case DemandPartnerDbName.APP_NEXUS:
        this.service.adUnitGet(hbId.bridgeAdUnitId).subscribe(adUnit => {
          this.matDialog.open(DpAutocreationAppnexusDialogComponent, <MatDialogConfig>{
            width: '600px',
            height: '650px',
            panelClass: 'appnexus-dialog',
            data: {
              adUnit: adUnit
            }
          }).afterClosed().subscribe(next => {
          });
        });
        break;
      case DemandPartnerDbName.PUBMATIC:
        this.service.adUnitGet(hbId.bridgeAdUnitId).subscribe(adUnit => {
          this.matDialog.open(DpAutocreationPubmaticComponent, <MatDialogConfig>{
            data: {
              adUnit: adUnit
            }
          }).afterClosed().subscribe(next => {
          });
        });
        break;
      case DemandPartnerDbName.RUBICON:
        this.service.adUnitGet(hbId.bridgeAdUnitId).subscribe(adUnit => {
          this.matDialog.open(DpAutocreationRubiconDialogComponent, <MatDialogConfig>{
            data: {
              adUnit: adUnit
            }
          }).afterClosed().subscribe(next => {
          });
        });
        break;
      default:
        this.sbs.error(hbId.demandPartner + ' unit creation not supported');
    }
  }

}
